import React from 'react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden bg-softwhite" data-id="element-61">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-cream rounded-bl-[100px] -z-10 opacity-50 hidden md:block" data-id="element-62" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-64">
          <div className="max-w-2xl animate-[fadeUp_0.8s_ease-out_both]" data-id="element-65">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sage/10 text-sage-dark font-medium text-sm mb-6 border border-sage/20" data-id="element-66">
              <span className="w-2 h-2 rounded-full bg-sage animate-pulse" data-id="element-67" />
              Para mujeres de 35 a 50+ años
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-charcoal leading-tight mb-6" data-id="element-68">
              ¿Sientes que tu metabolismo se ha{' '}
              <span className="text-sage italic" data-id="element-69">"congelado"</span> al cumplir
              los 35?
            </h1>

            <p className="text-lg md:text-xl text-charcoal-light font-sans leading-relaxed mb-8" data-id="element-70">
              Descubre cómo reprogramar tus hormonas para quemar la "grasa de
              supervivencia" en 30 días... Sin contar una sola caloría, sin
              pasar hambre y sin castigarte con cardio extenuante.
            </p>

            <button onClick={scrollToOffer} className="w-full sm:w-auto px-8 py-4 bg-gold hover:bg-gold-dark text-white rounded-md font-sans font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 flex items-center justify-center gap-3 group" data-id="element-71">
              SÍ, QUIERO RECUPERAR MI METABOLISMO
              <span className="group-hover:translate-x-1 transition-transform" data-id="element-72">
                →
              </span>
            </button>
            <p className="text-sm text-charcoal-light mt-4 font-sans italic text-center sm:text-left" data-id="element-73">
              Acceso inmediato • Garantía de 7 días
            </p>
          </div>

          <div className="relative animate-[fadeUp_0.8s_ease-out_0.2s_both]" data-id="element-74">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-75">
              <img src="https://cdn.magicpatterns.com/uploads/po1Lo74xnweqczBYCngQfo/AD_CREATIVE_THUMBNAIL.png" alt="Transformación antes y después" className="w-full h-auto object-cover" data-id="element-76" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-77" />
            </div>

            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-cream hidden sm:flex items-center gap-4" data-id="element-78">
              <div className="w-12 h-12 bg-sage/10 rounded-full flex items-center justify-center text-sage" data-id="element-79">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-80">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" data-id="element-81" />
                </svg>
              </div>
              <div data-id="element-82">
                <p className="text-xs text-charcoal-light font-sans uppercase tracking-wider" data-id="element-83">
                  Resultados Reales
                </p>
                <p className="font-playfair font-bold text-charcoal" data-id="element-84">
                  En 30 Días
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}